import { InputHTMLAttributes, ReactNode } from 'react';

import Box from '@mui/material/Box';

export interface InputProps {
  error?: string;
  label?: string;
  icon?: ReactNode;
  fullwidth?: boolean;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  size?: 'small' | 'medium' | 'large';
}

export function Input({
  label,
  inputProps,
  icon,
  error,
  size = 'large',
  fullwidth = true,
}: InputProps) {
  const isSmall = size === 'small';
  return (
    <Box width={fullwidth ? '100%' : 'auto'}>
      <Box position={'relative'}>
        {label && (
          <label className="s-label" htmlFor={inputProps?.id || label}>
            {label}
          </label>
        )}
        <input
          {...inputProps}
          id={inputProps?.id || label}
          className={`s-input ${size} ${error ? 'invalid' : ''} ${icon ? 'show-icon' : ''} ${
            inputProps?.className
          } ${size}`}
        />
        {icon ? (
          <Box position={'absolute'} bottom={isSmall ? '8px' : '12px'} right={'14px'}>
            {icon}
          </Box>
        ) : null}
      </Box>
      {error && <p className="p-FieldError Error">{error}</p>}
    </Box>
  );
}
